import gql from 'graphql-tag';

import type { CustomerPersona } from 'src/data/persona';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSuggestVariationsArgs,
  BackendSuggestionRequest,
} from 'src/types/backend';

import { FRAGMENT_SUGGEST_REQUEST } from './schema';

const MUTATION = gql`
  mutation SuggestVariations(
    $projectId: ID!
    $assetType: String!
    $suggestionMode: String!
    $keywords: String
    $link: String
    $inputText: String
    $debugAcPrompt: String
    $generateMore: Boolean
    $numberOfVariations: Int
    $language: String
    $suggestionAnnotationId: ID
    $landingPageAssetId: ID
    $forceUsingKeywords: Boolean
    $activeSectionIndex: Int
    $sections: [BlogPostBuilderOutlineSectionInput]
    $rephrase: JSON
    $customerPersonaId: ID
    $tovInput: TovInput
    $allInstructionsData: JSON
  ) {
    suggestVariations(
      projectId: $projectId
      assetType: $assetType
      suggestionMode: $suggestionMode
      keywords: $keywords
      link: $link
      inputText: $inputText
      debugAcPrompt: $debugAcPrompt
      generateMore: $generateMore
      numberOfVariations: $numberOfVariations
      language: $language
      suggestionAnnotationId: $suggestionAnnotationId
      landingPageAssetId: $landingPageAssetId
      forceUsingKeywords: $forceUsingKeywords
      activeSectionIndex: $activeSectionIndex
      sections: $sections
      rephrase: $rephrase
      customerPersonaId: $customerPersonaId
      tovInput: $tovInput
      allInstructionsData: $allInstructionsData
    ) {
      ...SuggestionRequest
    }
  }
  ${FRAGMENT_SUGGEST_REQUEST}
`;

type Variables = Omit<
  BackendMutationSuggestVariationsArgs,
  'suggestionAnnotationId' | 'customerPersonaId'
> & {
  guidanceId?: BackendMutationSuggestVariationsArgs['suggestionAnnotationId'];
  customerPersona?: CustomerPersona;
};
type Result = BackendSuggestionRequest;

export const suggestVariations = async ({ guidanceId, customerPersona, ...rest }: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      suggestionAnnotationId: guidanceId,
      customerPersonaId: customerPersona?.id,
    },
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
